import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { connect } from 'react-redux';

import { getString } from '../../../helpers/stringHelpers';
import { types as routingTypes } from '../../../ducks/routing.js';
import styles from './styles.js';

const stringsComponent = 'breadcrumbs';

function Breadcrumbs(props) {
  const { currentPath, pageType, classes } = props;
  const breadcrumbs = [];

  let elementKey = 0;

  const homeTitle = getString(stringsComponent, 'HOME') || 'Home';

  breadcrumbs.push(
    <div className={classes.crumb} key={++elementKey}>
      <div className={classes.breadcrumbArrowContainer}></div>
      <a href='#/dash' className={classes.breadcrumbLink} key={elementKey}>
        {homeTitle}
      </a>
    </div>
  );

  const pathPieces = currentPath.split('/');
  for (let pathPiece of pathPieces) {
    if (!pathPiece || pathPiece === 'dash') {
      continue;
    }

    // Try to get the portal string for the breadcrumb item title.
    // If it doesn't exist, build the breadcrumb item title from the path piece.
    let breadcrumbTitle =
      getString(stringsComponent, pathPiece.toUpperCase().replace('-', '_')) ||
      pathPiece.charAt(0).toUpperCase() + pathPiece.slice(1).replace('-', ' ');

    // Wellbeing and goverment service pages have their breadcrumb title
    // defined from the data object itself.
    if (pageType == routingTypes.WELLBEING_CHILD) {
      for (let section of wellbeingSections) {
        const match = section.pages.find((child) => {
          return child.slug == String(decodeURIComponent(pathPiece));
        });
        if (match) {
          breadcrumbTitle = match.appBarTitle;
        }
      }
    } else if (pageType == routingTypes.SERVICE_CHILD) {
      const match = governmentServiceSections.find((child) => {
        return child.slug == String(decodeURIComponent(pathPiece));
      });
      if (match) {
        breadcrumbTitle = match.appBarTitle;
      }
    }

    let href =
      '#' +
      currentPath.substring(
        0,
        currentPath.indexOf(pathPiece) + pathPiece.length
      );

    // Do not show account type path piece on create arrangement page.
    if (pageType == routingTypes.ARRANGEMENT_CREATE) {
      if (pathPiece == 'create-arrangement') {
        href = '#' + currentPath;
      } else {
        continue;
      }
    }

    const crumbArrow = (
      <div className={classes.breadcrumbArrowContainer}>
        <ChevronRightIcon
          key={++elementKey}
          className={classes.breadcrumbArrow}
        />
      </div>
    );

    breadcrumbs.push(
      <div className={classes.crumb} key={++elementKey}>
        {crumbArrow}
        <a href={href} key={++elementKey} className={classes.breadcrumbLink}>
          {breadcrumbTitle}
        </a>
      </div>
    );
  }

  return <span className={classes.breadcrumbSpan}>{breadcrumbs}</span>;
}

function mapStateToProps(state) {
  return {
    currentPath: state.location.pathname,
    pageType: state.location.type,
  };
}

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(Breadcrumbs)
);
